module.exports = __webpack_public_path__ + "img/13.97cb1594.jpg";